import { Component } from '@angular/core';
import { MatDialogRef } from '@angular/material/dialog';
import { SessionService } from '../Services/session.service';

@Component({
    selector: 'app-exit-modal',
    templateUrl: './exit-modal.component.html',
    styleUrls: ['./exit-modal.component.scss'],
    standalone: false
})
export class ExitModalComponent {

  constructor(private readonly sessionService: SessionService,
              private dialogRef: MatDialogRef<ExitModalComponent>) { }

  exit(): void {
    this.dialogRef.close();
    this.sessionService.endSession()
  }

}
